import React from "react";
import { IPostLatestDatesResult } from "../../interface/IPostLatestDates";
import { formatDateTimeToReadable } from "../../utils/commonUtils";

type Props = {
  data: IPostLatestDatesResult | null;
};

const PostLatestDatesPanel: React.FC<Props> = ({ data }) => (
  <article className="bg-white rounded-2xl border border-light shadow-sm p-5">
    <p className="text-xs uppercase tracking-wide text-tertiary mb-1">
      Posts table — global latest
    </p>
    <p className="text-sm text-secondary mb-4">
      Newest row in the posts table (all scraping sources in scope).
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="rounded-xl bg-lightGray p-4">
        <p className="text-xs text-tertiary mb-2">Latest stored (createdAt)</p>
        {data?.latestByCreatedAt ? (
          <>
            <p className="text-sm font-medium text-primary break-all">
              {data.latestByCreatedAt.metaPostId}
            </p>
            <p className="text-sm text-secondary mt-2">
              Stored:{" "}
              {formatDateTimeToReadable(data.latestByCreatedAt.createdAt)}
            </p>
            <p className="text-sm text-secondary">
              Post date:{" "}
              {data.latestByCreatedAt.postDate
                ? formatDateTimeToReadable(data.latestByCreatedAt.postDate)
                : "—"}
            </p>
          </>
        ) : (
          <p className="text-sm text-tertiary">No data</p>
        )}
      </div>
      <div className="rounded-xl bg-lightGray p-4">
        <p className="text-xs text-tertiary mb-2">
          Latest published (postDate)
        </p>
        {data?.latestByPostDate ? (
          <>
            <p className="text-sm font-medium text-primary break-all">
              {data.latestByPostDate.metaPostId}
            </p>
            <p className="text-sm text-secondary mt-2">
              Post date:{" "}
              {data.latestByPostDate.postDate
                ? formatDateTimeToReadable(data.latestByPostDate.postDate)
                : "—"}
            </p>
            <p className="text-sm text-secondary">
              Stored:{" "}
              {formatDateTimeToReadable(data.latestByPostDate.createdAt)}
            </p>
          </>
        ) : (
          <p className="text-sm text-tertiary">No data</p>
        )}
      </div>
    </div>
  </article>
);

export default PostLatestDatesPanel;
